import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class ProductMeasureGroupLookupData {
    products: Array<DropdownOptionIntegerId>;
    measureGroups: Array<DropdownOptionIntegerId>;
}
